import React, { Dispatch, ReactElement, useEffect, useState } from 'react'
import flood from "../assets/floodlayer.png";
import { useMapLayersContext } from '../provider/MapLayers';
import { LocationMarkerPopup } from "../mainLayer/MainWindow";

type LayerFloodPropsType = {
    name: string;
    color?: string;
}

const LayerFlood = (props: LayerFloodPropsType) => {
    const { selectLayerInMap, loadLayerInMap } = useMapLayersContext();
    const [isSelectedFlood, setIsSelectedFlood] = useState<boolean>(false)
      
        useEffect(() => {
          if(loadLayerInMap === "flood"){
            setIsSelectedFlood(true);
            }else if(loadLayerInMap !== "flood"){
                setIsSelectedFlood(false);
            }
        }, [loadLayerInMap]);


          const floodIconClick = () => {
            if (loadLayerInMap !== "flood") {
              setIsSelectedFlood((prevState) => !prevState);
            }
          };
        
          useEffect(() => {
            if (isSelectedFlood) {
              selectLayerInMap("flood");
            }else{
              LocationMarkerPopup("floodnot");
            }
          }, [isSelectedFlood]);

    return (
        <div className={`subItemWrapper`}   onClick={(e) => floodIconClick()} onTouchStart={(e) => floodIconClick()}>
                {props.color && (
                    <div className={`colorBox ${isSelectedFlood ? 'selected' : ''}`} style={{backgroundColor: `${props.color}`}}></div>
                )}

                <div className={`colorBox ${isSelectedFlood ? 'selected' : ''}`}>
                    <img src={flood} alt="" />
                </div>

                <span>{props.name}</span>
                <div className={`hover-message`}>content on development</div>
            </div>
    )
}

export default LayerFlood;